/**
 * 営業所設定ページ用のスクリプト
 */
 if (is_route('section.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        section_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.section_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id']);
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function(results) {
            let keys = Object.keys(results);
            if (keys.find(key => key == 'company')) {
                $('[data-replace-name-company-id=' + results.company.id + ']').text(results.company.name);   
            }
            if (keys.find(key => key == 'section')) {
                $('[data-replace-name-section-id=' + results.section.id + ']').text(results.section.name);   
            }
        });
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        if (this.id === 'company-delete-submit') {
            let action = _request.create_affiliation_url(location.href, true, null, ['company_id']);
            action = _request.create_url(action.split('?')[0], _request.create_parameters(action));
            history.pushState(null, null, action);
        }
        _modal.submit(this, 'delete-modal', function() {
            // ツールバーの更新が必要なのでリロードする
            location.reload();
        });
    });

    /*---- メールアドレス追加 ----*/

    // メールアドレス追加ボタン押下時
    $(document).on('click', '#section-setting-modal button[name="add_email"]', function () {
        var count = $('#section-setting-modal .email-area').length;
        var area = $('#section-setting-modal .email-area:first').clone();

        area.find('input').each(function() {
            $(this).val('');
            var id = $(this).attr('id');
            var newId = id.replace(/_0/g , '_' + count);
            var label = area.find('label[for="' + id + '"]');
            var error = area.find('#' + id + '-errors');

            // ID書き換え
            $(this).attr('id', newId);
            label.attr('for', newId);

            // error初期化
            if (error.length > 0) {
                error.attr('id', newId + '-errors');
                error.find('span').html('');
            }
        });

        area.find('button').each(function() {
            $(this).prop('disabled', false);
        });

        // 最後に追加
        area.insertAfter('#section-setting-modal .email-area:last');

        // // 5件になったら追加ボタン殺す
        // if (count + 1 >= 5) {
        //     $(this).prop('disabled', true);
        // }
    });

    // メールアドレス削除ボタン押下時
    $(document).on('click', '.delete-email', function () {
        $(this).closest('.email-area').remove();
    });
    

}